<template lang="html">
  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card :body-style="{height:'156px'}">
          <span>累计收入</span>
          <h3>￥ {{accountMoneyInfo.accumulativeInMoney}}</h3>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card :body-style="{height:'156px'}">
          <span>累计提现</span>
          <h3>￥ {{accountMoneyInfo.accumulativeOutMoney}}</h3>
        </el-card>
      </el-col>
      <el-col v-loading="wechatInfoLoading" element-loading-text="授权检测中...." :span="8">
        <el-card :body-style="{height:'156px'}">
          <span>账户余额</span>
          <h3>￥{{accountMoneyInfo.accumulativeResidueMoney}}</h3>
          <div style="padding-top:20px;padding-bottom:10px;">
            <img  style="width:18px;height:18px;" :src="accountMoneyInfo.headImgUrl?accountMoneyInfo.headImgUrl:'static/wechat.jpg'"/>
            <span style="margin-left:5px;">{{accountMoneyInfo.bindOk?accountMoneyInfo.nickname:'未绑定提现微信'}}</span>
            <el-button v-if="accountMoneyInfo.QrcodeUrl" type="text" style="margin-left:5px;" size="mini" @click="showQR">提现</el-button>
            <el-button v-else type="text" size="mini" style="margin-left:5px;" @click="withdrawCash">提现到微信钱包</el-button>
          </div>

        </el-card>
      </el-col>
    </el-row>
    <el-tabs class="basic-margin" v-model="activeName">
      <el-tab-pane label="收入明细" name="first">
        <income></income>
      </el-tab-pane>
      <el-tab-pane label="提现记录" name="second">
        <withdraw-cash></withdraw-cash>
      </el-tab-pane>
    </el-tabs>

    <!-- 提现弹窗框 -->
    <withdraw-cash-dialog ref="withdraw-cash-dialog"></withdraw-cash-dialog>
  </div>
</template>

<script>
import WithdrawCash from './WithdrawCash'
import Income from './Income'
import ChannelModel from '@/framework/models/channelModel'
import BasicPager from '@/mixins/BasicPager'
import WithdrawCashDialog from './children/WithdrawCashDialog'
export default {
  name: 'final-center',
  extends: BasicPager,
  components: {
    Income,
    WithdrawCash,
    WithdrawCashDialog
  },
  data: function () {
    return {
      wechatInfoLoading: false,
      accountMoneyInfo: {},
      activeName: 'first'
    }
  },
  created: function () {
    this.selectAccountMoney()
  },
  methods: {
    showQR: function () {
      const h = this.$createElement
      let QrcodeUrl = this.accountMoneyInfo.QrcodeUrl
      let _this = this
      this.$msgbox({
        title: '',
        message: h('p', { style: { textAlign: 'center', padding: '20px' } }, [
          h('span', null, '请打开手机微信扫描二维码进行绑定'),
          h('img', { attrs: { src: QrcodeUrl }, style: 'color: teal;margin-top:10px;' }, 'VNode')
        ]),
        showCancelButton: true,
        confirmButtonText: '我已扫码授权',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action == 'confirm') {
            this.wechatInfoLoading = true
            setTimeout(function () {
              _this.selectAccountMoney()
            }, 3000)
          }

          done()
        }
      })
    },
    withdrawCash: function () {
      this.$refs['withdraw-cash-dialog'].show(this.accountMoneyInfo.nickname)
      this.$refs['withdraw-cash-dialog'].canUseMoney = this.accountMoneyInfo.canUseMoney
      this.$refs['withdraw-cash-dialog'].otherMoney = this.accountMoneyInfo.accumulativeResidueMoney - this.accountMoneyInfo.canUseMoney
    },
    selectAccountMoney: function () {
      // 不是渠道不进行查询
      if (this.loginInfo.loginPath != 'channel') {
        return
      }

      let _this = this
      let params = {
        channelId: this.loginInfo.id
      }
      let listener = {
        success: function (dataInfo) {
          _this.accountMoneyInfo = dataInfo.datas
          if (_this.wechatInfoLoading) {
            _this.wechatInfoLoading = false
            if (!_this.accountMoneyInfo.headImgUrl) {
              _this.$message.error('未成功授权，请重新扫码或刷新页面')
            }
          }
        }
      }
      ChannelModel.selectAccountMoney(_this, params, listener)
    }
  }
}
</script>

<style lang="css">
</style>
